import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { AddBox } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CachedIcon from "@material-ui/icons/Cached";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import EqualizerIcon from "@material-ui/icons/Equalizer";

const defaultToolbarStyles = {
  iconButton: {
    marginRight: "24px",
    top: "50%",
    display: "inline-block",
    position: "relative",
    transform: "translateY(-50%)",
  },
  deleteIcon: {
    color: "#000",
  },
  nostyle: {
    margin: 0,
    padding: 0,
  },
};

const CustomToolbar = ({
  handleAdd,
  handleRefetch,
  handleDownload,
  handleChart,
  HandleCustomButtom,
}) => {
  const handleClick = () => {
    handleAdd();
  };

  return (
    <span>
      {handleChart && (
        <Tooltip title={"Grafik Görünüm"}>
          <IconButton
            //className={classes.CustomToolbar}
            onClick={handleChart}
          >
            <EqualizerIcon />
          </IconButton>
        </Tooltip>
      )}
      {handleDownload && (
        <Tooltip title={"İndir"}>
          <IconButton
            //className={classes.CustomToolbar}
            onClick={handleDownload}
          >
            <CloudDownloadIcon />
          </IconButton>
        </Tooltip>
      )}
      {HandleCustomButtom && <HandleCustomButtom />}
      {handleAdd && (
        <Tooltip title={"Yeni Kayıt Ekle"}>
          <IconButton
            //className={classes.CustomToolbar}
            onClick={handleClick}
          >
            <AddBox />
          </IconButton>
        </Tooltip>
      )}
      {handleRefetch && (
        <Tooltip title={"Yenile"}>
          <IconButton
            //className={classes.CustomToolbar}
            onClick={handleRefetch}
          >
            <CachedIcon />
          </IconButton>
        </Tooltip>
      )}
    </span>
  );
};

export default withRouter(
  withStyles(defaultToolbarStyles, {
    name: "CustomToolbar",
  })(CustomToolbar)
);
